export default "__VITE_ASSET__946feb92__"